<template>
    <div class="ele-container ele-shopList">
        <div class="list-head-container" :class="{'hasItem': child.name}">
            <div class="head-filter">
                <div @click="closePage" v-if='!fromXBH'>
                    <!-- <Svgs color="#000" name="iconfanhui"></Svgs> -->
                </div>
                <div class="address" v-show="!child.name" @click="goAddress">
                    <span class="text">
                        {{ eleAddress.addressName || "请选择收货地址" }}
                    </span>
                    <Svgs class="down" color="#E1E1E1" name="iconfontdown"></Svgs>
                </div>
				<div class="child-name">{{child.name}}</div>
                <div class="list-head-icon" @click="openFilter('sort')">
                    <Svgs color="#000" name="iconshaixuan1"></Svgs>
                </div>
				<div class="list-head-icon" @click="openFilter('filter')">
                    <Svgs color="#000" name="iconfilter"></Svgs>
                </div>
            </div>
            <div class="ele-shoplist-search">
                <div class="smart-search-input">
                    <Svgs color="#C0C4CD" class="input-search-icon" name="iconsousuo"></Svgs>
                    <form action="javascript:return true">
                        <input
                            type="search"
                            v-model="eleKeyword"
                            @click="goSearch"
                            placeholder="请输入餐厅名称"
                        />
                    </form>
                    <span v-show="eleKeyword" class="input-clear-icon" @click="clearEleKeyword">
                        <Svgs color="#C0C4CD" name="iconshanchu3"></Svgs>
                    </span>
                </div>
            </div>
            <div class="ele-sort" v-show="sortShow">
                <ul v-show="type == 'sort'">
                    <li
                        v-for="(item, index) in orderByList"
                        :key="index"
                        @click="setOrderBy(item)"
                    >
                        {{ item.txt }}
                        <Svgs
                            v-if="params.orderBy == item.val"
                            :color="color"
                            name="iconyiwancheng"
                        ></Svgs>
                    </li>
                </ul>
                <div class="ele-filter" v-show="type == 'filter'">
                    <div class="ele-title">商家分类</div>
                    <van-button
                        v-for="(item, index) in category"
                        :key="index"
                        round
                        size="small"
                        :type="params.categoryIds.includes(item.id) ? 'primary' : 'default'"
                        @click="setCategory(item)"
                    >
                        {{ item.name }}
                    </van-button>
                    <div class="ele-title">人均</div>
                    <van-button
                        v-for="(item, index) in priceList"
                        :key="index"
                        round
                        size="small"
                        :type="computeClass(item) ? 'primary' : 'default'"
                        @click="choosePrice(item)"
                    >
                        {{ item.txt }}
                    </van-button>
                    <div class="ele-title">商家服务</div>
                    <van-button
                        v-for="(item, index) in serviceList"
                        :key="index"
                        round
                        size="small"
                        :type="params[item.val] ? 'primary' : 'default'"
                        @click="setService(item)"
                    >
                        {{ item.txt }}
                    </van-button>
                    <div class="ele-foot-btn">
                        <van-button round @click="reset"> 重置 </van-button>
                        <van-button round type="primary" @click="submit">
                            完成
                        </van-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="shopListContent" :class="{ 'hidden': this.sortShow}">
            <div v-show="!child.name" class="grid-box">
				<div class="grid-item" @click="setChild(item)" v-for="(item, index) in otherList" :key="index">
					<Svgs color="#C0C4CD" :name="item.icon"></Svgs>
					<div>{{item.name}}</div>
				</div>
			</div>
            <noData v-if="!shopList.length" noDataTxt="暂无数据" />
            <van-pull-refresh
                v-else
                v-model="isDownLoading"
                @refresh="onDownRefresh"
            >
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    finished-text="已显示所有数据"
                    @load="onLoad"
                >
                    <template v-for="item in shopList">
                        <ShopItem :item="item.restaurant || item" :key="(item.restaurant || item).erestaurantId" />
                    </template>
                </van-list>
            </van-pull-refresh>

            <van-overlay :show="sortShow" @click="closeFilter" />
        </div>
        <van-popup
            round
            v-model="showPositionLoad"
            class="ele-location"
            :close-on-click-overlay="false"
        >
            <van-loading />定位中...
        </van-popup>
    </div>
</template>

<script>
import ShopList from "./ShopList.js";
export default ShopList;
</script>

<style lang="scss">
@import "ShopList";
</style>